import {
  DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_BEGIN,
  DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_SUCCESS,
  DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_FAILURE,
  DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
export function updateTablesAndFieldsAppwrite(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_BEGIN,
    });
    const { projectId, version, dbUuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/appwrites/fields-tables/${dbUuid}`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_SUCCESS,
            data: res,
          });
          resolve(res);
          console.log('apdated res here tables ', res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateTablesAndFieldsAppwriteError() {
  return {
    type: DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updateTablesAndFieldsAppwritePending: true,
        updateTablesAndFieldsAppwriteError: null,
      };

    case DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_SUCCESS:
      // The request is success
      return {
        ...state,
        updateTablesAndFieldsAppwritePending: false,
        updateTablesAndFieldsAppwriteError: null,
      };

    case DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_FAILURE:
      // The request is failed
      return {
        ...state,
        updateTablesAndFieldsAppwritePending: false,
        updateTablesAndFieldsAppwriteError: action.data.error,
      };

    case DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updateTablesAndFieldsAppwriteError: null,
      };

    default:
      return state;
  }
}
